$(function () {
  const host = "https://dip.sylvoxtv.com/api/api";
  const picHost = "https://dip.sylvoxtv.com/";
  const MAX_SIZE = 50 * 1024 * 1024;
  const MIN_FILES = 2;
  const MAX_FILES = 5;
  let uploadedFiles = [];
  let fileLinks = [];

  $("#multiImgPreview").on("click", "#multiUploadBtn", function () {
    if (uploadedFiles.length >= MAX_FILES) {
      showFormError("Téléverser un fichier", `Limite maximale atteinte`);
      return false;
    }
    $("#fileUpload").click();
  });
  $("#fileUpload").change(function () {
    const files = Array.from(this.files);
    if (validateFiles(files)) {
      Array.from(files).forEach(function (file, idx) {
        uploadedFiles.push(file);
        // var reader = new FileReader();
        // reader.onload = function (evt) {
        //   multiImgData.push(evt.target.result);
        // };
        // reader.readAsDataURL(file);
      });
      $(this).val("");
      renderPreviews();
    }
  });

  function validateFiles(files) {
    var totlFiles = files.length + uploadedFiles.length;
    if (totlFiles > MAX_FILES || files.length > MAX_FILES) {
      showFormError(
        "Téléverser un fichier",
        `Veuillez sélectionner entre ${MIN_FILES} et ${MAX_FILES} fichiers`
      );
      return false;
    }

    const invalidFiles = files.filter((file) => {
      const validTypes = [
        "image/jpeg",
        "image/png",
        "video/mp4",
        "video/avi",
        "video/quicktime",
        "video/x-m4v",
        "video/mov",
        "image/jpg",
      ];
      return !validTypes.includes(file.type) || file.size > MAX_SIZE;
    });

    if (invalidFiles.length) {
      showFormError(
        "Téléverser un fichier",
        "Format de fichier invalide ou taille maximale dépassée (50 Mo max)"
      );
      return false;
    }
    return true;
  }
  function renderPreviews() {
    let imgHtml = "";
    $("#multiImgPreview").empty();
    uploadedFiles.forEach((file, index) => {
      const previewUrl = URL.createObjectURL(file);
      const isImage = file.type.startsWith("image/");
      imgHtml += `
        <div class="file-preview" data-index="${index}">
          ${
            isImage
              ? `<img src="${previewUrl}" class="file-thumbnail">`
              : `<div class="video-thumbnail">
              <video width="80" height="80">
                <source src="${previewUrl}" type="${file.type}">
              </video>
            </div>`
          }
            <div type="button" class="remove-file"  data-index="${index}" title="delete">×</div>
        </div>
      `;
    });
    imgHtml += `
        <div class="multi-upload-btn" id="multiUploadBtn">
            <svg
            t="1747823126898"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="1493"
            width="32"
            height="32"
            >
            <path d="M1020.192947 541.265648h-460.281325v482.734352h-78.889013V541.265648H3.761254v-78.877563h477.307154V0h78.889013v462.388085h460.281325v78.877563z" fill="#707070" p-id="1494"></path>
            </svg>
        </div>
    `;
    $("#multiImgPreview").append(imgHtml);
  }
  $("#multiImgPreview").on("click", ".remove-file", function () {
    const index = $(this).attr("data-index");
    uploadedFiles.splice(index, 1);
    renderPreviews();
  });
  let submitLoading = false
  $("form").submit(function (e) {
    e.preventDefault();
    if(submitLoading) return showFormError("", "Téléversement en cours…");
    // 验证必填字段
    if (!$(".contact_name").val()) {
      showFormError("Nom", "Veuillez indiquer votre nom.");
      return false;
    }
    if (!$(".contact_email").val()) {
      showFormError("E-mail", "Veuillez saisir votre adresse e-mail.");
      return false;
    }
    if (uploadedFiles.length < MIN_FILES) {
      showFormError("Téléverser un fichier", `Veuillez sélectionner au moins ${MIN_FILES} fichiers.`);
      return false;
    }
    const formData = new FormData();
    uploadedFiles.map((file) => {
      formData.append("files", file);
    });
    // 构造JSONP元数据
    const meta = {
      files: Array.from(uploadedFiles).map((f) => f.name),
      callback: "handleUploadResponse",
    };
    formData.append("meta", `jsonpCallback(${JSON.stringify(meta)})`);
    $('.submit-btn').attr('disabled',true);
    $('.submit-btn svg').css('display','inline');
    submitLoading = true
    // 上传文件
    $.ajax({
        url: host + "/uploadfiles", // 替换为实际的上传端点
        type: "POST",
        data: formData,
        processData: false,
        contentType: false,
        xhr: function () {
        const xhr = new XMLHttpRequest();
        xhr.upload.addEventListener("progress", function (e) {
            if (e.lengthComputable) {
                const percent = Math.round((e.loaded / e.total) * 100);
                $('#progress-container').css('display','flex');
                $(`#upload-progress`).val(percent);
                $("#progress-text").text(percent + "%");
            }
        });
        return xhr;
        },
        success:  res=> {
            $('#progress-container').css('display','none');
            if (res.Code == 0) {
                res.location.forEach(item=>{
                    fileLinks.push(picHost + item);
                });
                updateMessageBody();
                this.submit();
            } else {
                showFormError("", res.Msg);
                $('.submit-btn').attr('disabled',false);
                $('.submit-btn svg').css('display','none');
            }
        },
        error: function () {
            showFormError("", "Échec du téléversement des fichiers.");
            $('#progress-container').css('display','none');
            $('.submit-btn').attr('disabled',false);
            $('.submit-btn svg').css('display','none');
        },
    });
    return false;
  });
  function showFormError(field, message) {
    if($('.note--success')){
        $('.note--success').css('display','none');
    }
    const errorHtml = `${field ? field + ":" : ""}${message}`;
    $(".error-text").text(errorHtml);
    $(".isshow").css("display", "block");
    setTimeout(() => {
      $(".isshow").css("display", "none");
    }, 3000);
  }
  function updateMessageBody() {
    let filetext = ''
    if (fileLinks.length) {
      filetext+= "\n\nAttachments:\n" + fileLinks.join("\n");
    }
    $("#file-url").val(filetext);
  }
});
